import createConditionCatalog from '@/helpers/createConditionCatalog';

export default createConditionCatalog([
  {
    name: 'included',
    label: 'included',
    value: null,
  },
  {
    name: 'not_included',
    label: 'not included',
    value: null,
  },
]);
